import type { Dashboard, EnabledDashboard } from './types';

export const DashboardPriorityList: EnabledDashboard[] = [
  'CLINICAL',
  'HYGIENE',
  'ENGAGEMENT',
];

export const DashboardMap: Record<EnabledDashboard, Dashboard> = {
  CLINICAL: 'CLINICAL_MENTORING_BETA',
  HYGIENE: 'HYGIENE_TASKS',
  ENGAGEMENT: 'ENGAGEMENT',
};

export const DashboardUrls: Record<Dashboard, { prod: string; dev?: string }> =
  {
    CLINICAL_MENTORING_ALPHA: {
      prod: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/DSODashboard/Summary2',
    },
    CLINICAL_MENTORING_BETA: {
      prod: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/ClinicalMentoringDashboardBeta/ClincalMentoring',
      dev: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/ClinicalMentoringDashboard/ClincalMentoring',
    },
    ENGAGEMENT: {
      prod: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/CleanDSODashboardEmbedded1/Engagement',
      dev: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/CleanDSODashboardEmbedded/Engagement',
    },
    PROVIDER_DETAIL: {
      prod: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/ClinicalMentoringProviderLevelBeta/ProviderLevel',
      dev: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/ClinicalMentoringProviderLevelBeta_17364600068080/ProviderLevel',
    },
    HYGIENE_TASKS: {
      prod: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/HygieneTasksDashboard_17364548322350/HygieneTasks',
      dev: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/HygieneTasksDashboard/HygieneTasks',
    },
    PRACTICE_DETAIL: {
      prod: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/HygienePracticeLevelBeta/HygieneTasks',
      dev: 'https://us-east-1.online.tableau.com/t/videahealthimpression/views/HygieneLevelDEV/HygieneTasks',
    },
  } as const;

export const parameterNames = [
  'Start Date',
  'End Date',
  'Completed Weeks Only',
  'Benchmark',
] as const;
